import { Query } from '@varo/graphql-schema-types';
import { formatSelfFundedOfferComponents } from 'features/rewards/helpers/formatSelfFundedOfferComponents';
import getSelfFundedOfferComponents from 'services/graphql/queries/rewards/GetSelfFundedOfferComponents';
import { useStatsig } from 'shared/hooks/statsig/useStatsig';
import { FeatureFlagKey } from 'shared/providers/statsig/StatsigProvider.d';
import { useQuery } from 'urql';

const useSelfFundedOfferComponents = () => {
  const { isFeatureEnabled } = useStatsig();
  const isSelfFundedOffersEnabled = isFeatureEnabled(
    FeatureFlagKey.ENABLE_SELF_FUNDED_OFFERS,
  );

  const [{ data, fetching: loading, error, stale }] = useQuery<Query>({
    query: getSelfFundedOfferComponents,
    requestPolicy: 'cache-and-network',
    pause: !isSelfFundedOffersEnabled,
  });

  const offerCards = formatSelfFundedOfferComponents(
    data?.selfFundedOfferComponents,
  );

  return {
    offerCards,
    loading,
    error,
    stale,
  };
};

export default useSelfFundedOfferComponents;
